import { getConfig } from '../config'

export const fetchWithChecksum = async (url, options = {}) => {
  try {
    const config = getConfig()
    const checksumValue = config['x-checksum']
    
    const headers = {
      'Content-Type': 'application/json',
      'x-checksum': checksumValue,
      ...options.headers
    }
    
    return fetch(url, {
      ...options,
      headers
    })
  } catch (error) {
    console.error('带校验和的fetch请求出错:', error)
    return fetch(url, options)
  }
}

export const get = async (url, options = {}) => {
  return fetchWithChecksum(url, {
    method: 'GET',
    ...options
  })
}

export const post = async (url, data = null, options = {}) => {
  return fetchWithChecksum(url, {
    method: 'POST',
    body: data ? JSON.stringify(data) : null,
    ...options
  })
}

export const put = async (url, data = null, options = {}) => {
  return fetchWithChecksum(url, {
    method: 'PUT',
    body: data ? JSON.stringify(data) : null,
    ...options
  })
}

export const del = async (url, options = {}) => {
  return fetchWithChecksum(url, {
    method: 'DELETE',
    ...options
  })
}
